import React from 'react';
import birlanuWaterLogo from '../../assets/images/birlanu_water_tank_logo.svg';
import CKALogo from '../../assets/images/CKA Birla_Logo.svg';
import '../../styles/privacyPolicy.css';
// import { Link } from 'react-router-dom';
const PrivacyPolicy = () => {
    return (
        <div className="privacyPolicy">
            <div className="header">
                <div className="logo">
                    <img src={birlanuWaterLogo} alt="BirlaNU Logo" />
                </div>
                {/* <h1>Terms of Service</h1> */}
                <img src={CKALogo} alt="CKA Logo" />
            </div>
            <div className="policyContainer">
                {/* <div className="top-pagination">
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li>Privacy Policy</li>
                    </ul>
                </div> */}
                <h3>Privacy Policy – BirlaNu Water Tanks</h3>
                <section>
                    <h2>INTRODUCTION</h2>
                    <p>BirlaNu Limited (formerly HIL Limited) (“Company”, “We”, “Us”, “Our”) values the privacy of individuals using our BirlaNu Water Tanks <strong>/Smart Lid (‘product’/‘Device’)</strong> and related mobile/web applications (collectively referred to as the “<strong>Services</strong>”).</p>
                    <p>This Privacy Policy (‘<strong>Policy</strong>’) explains how we collect, use, disclose, and safeguard your information when you use our Services including usage of Product, water monitoring features such as water level, temperature, TDS monitoring, and solar-powered battery status.</p>
                    <p>By using the Product, you acknowledge and agree to the practices described in this Privacy Policy.</p>
                </section>
                <section>
                    <h2>GOVERNING LAW</h2>
                    <p>This Privacy Policy is governed by applicable Indian privacy laws and, where applicable, the EU General Data Protection Regulation (GDPR), BirlaNu – Data Protection Statement and other relevant data protection frameworks.</p>
                </section>
                <section>
                    <h2>APPLICABILITY</h2>
                    <p>This Policy is applicable to all users, visitors, customers, technicians, and any individual providing their personal or usage-related data through the Smart Lid device, associated apps, or our websites.</p>
                </section>
                <section>
                    <h2>OBJECTIVE</h2>
                    <p>The purpose of this Privacy Policy is to provide transparency on:</p>
                    <ul>
                        <li>The nature and the manner of information We collect.</li>
                        <li>The sources from where the information is collected (in case other than personal data is collected directly from you).</li>
                        <li>How the collected data is used, stored, and processed.</li>
                        <li>When and with whom your information is shared.</li>
                        <li>Your rights as a user and how to exercise them.</li>
                    </ul>
                </section>
                <section>
                    <h2>CATEGORIES OF INFORMATION COLLECTED</h2>
                    <p><strong>(A) Personal Information (if applicable): </strong>Personal information means any information, relating to an identified or identifiable person, includes name, mobile number, email id, address, and location.</p>
                    <p><strong>(B) Device & Usage Data:</strong></p>
                    <ul>
                        <li>Device identifiers (serial number, device ID, IP address).</li>
                        <li>Water level readings.</li>
                        <li>Water temperature and TDS readings.</li>
                        <li>Battery status (including solar charging performance).</li>
                        <li>Usage patterns of the mobile application.</li>
                    </ul>
                    <p><strong>(C) Cookies & Analytics:</strong></p>
                    <p>If you use the mobile app or website, cookies and similar technologies may collect:</p>
                    <ul>
                        <li>Session/usage information, IP address, device type.</li>
                        <li>App/website browsing activity for service improvement.</li>
                    </ul>
                </section>
                <section>
                    <h2>HOW WE COLLECT DATA</h2>
                    <p>We collect data through:</p>
                    <ul>
                        <li>Information provided by you directly including during setup, registration, or customer support.</li>
                        <li>Automatic collection from the device and mobile application.</li>
                        <li>Cookies and analytics on our website/app.</li>
                    </ul>
                </section>
                <section>
                    <h2>WHY WE COLLECT YOUR DATA (PURPOSES OF PROCESSING)</h2>
                    <p>We collect and process data for:</p>
                    <ul>
                        <li><strong>Service Functionality: </strong>To measure and display water levels, temperature, TDS, and battery performance in real-time.</li>
                        <li><strong>Customer Support & Maintenance: </strong>To resolve issues, troubleshoot, and provide technical support.</li>
                        <li><strong>Product Improvement: </strong>To enhance device performance, accuracy, and features.</li>
                        <li><strong>Legal & Compliance: </strong>To meet legal, regulatory, and warranty obligations.</li>
                        <li><strong>Communication: </strong>To send important product updates, safety alerts, or service notices.</li>
                    </ul>
                    <p>We do not sell your personal data.</p>
                </section>
                <section>
                    <h2>CHANGE OF PURPOSE</h2>
                    <p>We will only use your data for the purposes specified above. If a new purpose arises, you will be notified in advance.</p>
                </section>
                <section>
                    <h2>USE BY MINORS</h2>
                    <p>The Smart Lid and associated applications are not intended for use by individuals under 18 years of age. We do not knowingly collect/process data from minors.</p>
                </section>
                <section>
                    <h2>INFORMATION SHARING AND DISCLOSURE</h2>
                    <p>We may share your data:</p>
                    <ul>
                        <li>With authorized service technicians for maintenance;</li>
                        <li>With third-party service providers (e.g., cloud hosting, analytics providers) under strict confidentiality agreements;</li>
                        <li>With regulators, auditors, or legal authorities when legally required;</li>
                        <li>With any member (including employees) of the Company;</li>
                    </ul>
                    <p>in so far as reasonably necessary for the purposes set out in this policy and for the purpose of providing services to you.</p>
                </section>
                <section>
                    <h2>DATA SECURITY</h2>
                    <p>BirlaNu Water Tanks uses industry-standard encryption and security practices to protect your data from unauthorized access, alteration, or disclosure.</p>
                    <p>The Company endeavors to ensure that the data disclosed by you is as secure as possible. To that end, Company have implemented number of technical and organizational measures which protect your personal data from unauthorized or unlawful processing and from unintentional loss, destruction or damage.</p>
                </section>
                <section>
                    <h2>DATA RETENTION</h2>
                    <p>Your information will be retained only as long as necessary for service provision, legal compliance, or warranty purposes. After the retention period, data will be securely deleted or anonymized.</p>
                </section>
                <section>
                    <h2>YOUR RIGHTS</h2>
                    <p>Depending on applicable law, you may have the right to:</p>
                    <ul>
                        <li>Access, correct, or delete your personal data.</li>
                        <li>Restrict or object to data processing.</li>
                        <li>Withdraw consent (where consent was given).</li>
                        <li>Request data portability.</li>
                    </ul>
                    <p>To exercise these rights, contact us at: <a href="mailto:dataprivacy@birlanu.com">dataprivacy@birlanu.com</a></p>
                </section>
                <section>
                    <h2>CHANGES TO THIS POLICY</h2>
                    <p>We may update this Privacy Policy to reflect new features, regulatory changes, or business needs. The latest version will always be available on our website and app.</p>
                </section>
                <section>
                    <h2>CONTACT INFORMATION</h2>
                    <p>For any queries, complaints, or requests related to privacy and data protection, please contact:</p>
                    <p><a href="mailto:smarttank.support@birlanu.com">smarttank.support@birlanu.com</a></p>
                    <p>BirlaNu Limited (formerly HIL Limited), Office No 1 & 2, L7 Floor, SLN Terminus, Survey No. 133, Near Botanical Gardens, Gachibowli, Hyderabad, Telangana, India, 500032</p>
                </section>

            </div>
        </div>
    );
};

export default PrivacyPolicy;
